import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { UserIdentityAPIService } from 'wflow-main-app/src/app/core/api';
import { APP_ROUTES } from 'wflow-main-app/src/app/routing.const';

export function ContactSupportGuard(): Observable<boolean | UrlTree> {
  const userSvc = inject(UserIdentityAPIService);
  const router = inject(Router);

  return userSvc.getMyOrganizations().pipe(
    map(({ organizationIds }) => {
      if (organizationIds.length === 0) {
        return true;
      }

      return router.createUrlTree([APP_ROUTES.DASHBOARD]);
    }),
    catchError(() => of(true)),
  );
}
